import { frozenProcurementOverview } from '../../../../lib/supplyChainMaterialScope';
import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { walkCitationText } from '../../../../lib/walkCitationText';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { roleColor } from '../../../../lib/reportRoleColors';
import { EditorialKpiRail } from '../../report/editorial';
import { SectionShell } from '../SectionShell';
import { resolveSupplyChainPlan } from '../../../../lib/reportRendering/supplyChainPlan';

/**
 * W2b editorial port — the ad-hoc hairline Stat grid becomes an
 * EditorialKpiRail (the Exec D1 / Power 4A rail idiom): mono small-caps
 * keys over tabular-numeric values, bounded by hairline rules. Inputs are
 * unchanged (plan counts + quote coverage); the narrative paragraph keeps
 * its citation walking. hasData semantics are identical (plan OR narrative).
 */
export const ProcurementOverviewSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const plan = resolveSupplyChainPlan(report);
  const narrative = frozenProcurementOverview(report);
  const quoteCoverage = plan
    ? new Set(plan.quotes.map((q) => q.bomItemId)).size
    : 0;
  const hasData = !!(plan || narrative);

  return (
    <SectionShell label={label} hasData={hasData} report={report} sectionId="procurementOverview" required>
      {plan && (
        <EditorialKpiRail
          theme={theme}
          items={[
            { key: 'BoM lines', value: plan.bom.length },
            { key: 'Suppliers', value: plan.suppliers.length },
            { key: 'Quotes', value: plan.quotes.length },
            { key: 'Quoted BoM items', value: quoteCoverage },
          ]}
        />
      )}
      {narrative && (
        <p style={{ color: roleColor(theme, 'body') }}>{walkCitationText(narrative, report.references)}</p>
      )}
    </SectionShell>
  );
};
